import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "m12.9 12.367-.1.135q-.051.066-.1.133l-1.334-.996.202-.27zm-4.733-1.25L5.591 9.572l-.118-.071H4.167v2.667h-.333V9.501H2.667a.837.837 0 0 1-.833-.833V7.335c0-.457.376-.834.833-.834h2.806l.118-.071 2.576-1.546zm6-3.282v.333h-1.666v-.333zm-1.268-4.2c-.433.326-.904.678-1.333.999l-.098-.132-.1-.135 1.332-1z"
    }, null, -1)
  ]))]))
}
export default { render: render }